module.exports = __webpack_public_path__ + "static/img/layout7.7271ccc5.png";